/* ==========================================================================
   AMBIENT HOME — Ambient Pro (page professionnels)
   Fichier : assets/ah-pro.js
   - apparition douce des blocs au défilement
   - défilement fluide vers le formulaire
   - glisser pour faire défiler les secteurs (souris)
   - pré-remplissage du produit consulté (?produit=…)
   - bouton « Demander un devis » fixe sur mobile
   ========================================================================== */

(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (!root || root.__ahp) return;
    root.__ahp = true;

    /* Apparition au défilement */
    var items = root.querySelectorAll('[data-ahp-reveal]');
    if ('IntersectionObserver' in window && !reduce) {
      root.classList.add('js-reveal');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      items.forEach(function (el) { io.observe(el); });
    } else {
      items.forEach(function (el) { el.classList.add('is-in'); });
    }

    /* Défilement fluide vers les ancres internes */
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-ahp-scroll]');
      if (!a) return;
      var id = (a.getAttribute('href') || '').replace('#', '');
      var target = id && document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
      window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
      var formEl = target.tagName === 'FORM' ? target : target.querySelector('form');
      if (formEl) {
        var first = formEl.querySelector('input:not([type="hidden"]), select, textarea');
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, reduce ? 0 : 650);
      }
    });

    function headerOffset() {
      var h = document.querySelector('.shopify-section-header-sticky, sticky-header, .header-wrapper, header');
      var r = h ? h.getBoundingClientRect() : null;
      return (r && r.bottom > 0 && r.bottom < 200 ? r.bottom : 0) + 24;
    }

    /* Glisser pour faire défiler les secteurs (souris uniquement) */
    root.querySelectorAll('[data-ahp-track]').forEach(function (track) {
      var down = false, moved = false, startX = 0, startLeft = 0;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; moved = false;
        startX = e.clientX; startLeft = track.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 4) { moved = true; track.classList.add('is-dragging'); }
        if (moved) track.scrollLeft = startLeft - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!down) return;
        down = false;
        track.classList.remove('is-dragging');
      });
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    });

    /* Formulaire */
    var form = root.querySelector('.ahp-form');
    if (form) {
      form.querySelectorAll('.ahp-field--select select').forEach(function (sel) {
        var wrap = sel.closest('.ahp-field');
        var sync = function () { wrap.classList.toggle('has-value', !!sel.value); };
        sel.addEventListener('change', sync);
        sync();
      });

      /* Produit consulté depuis une fiche produit (?produit=…) */
      var params = new URLSearchParams(window.location.search);
      var product = params.get('produit');
      var hidden = form.querySelector('[data-ahp-product]');
      if (product) {
        product = product.slice(0, 180);
        if (hidden) hidden.value = product;
      }

      form.addEventListener('submit', function () {
        var btn = form.querySelector('[data-ahp-submit]');
        if (btn && form.checkValidity()) {
          setTimeout(function () { btn.setAttribute('disabled', ''); }, 0);
        }
      });

      /* Après envoi : on ramène le visiteur sur le message de confirmation */
      var done = form.querySelector('[data-ahp-done]') || form.querySelector('.ahp-form__error');
      if (done) {
        setTimeout(function () {
          var top = form.getBoundingClientRect().top + window.pageYOffset - headerOffset();
          window.scrollTo({ top: top, behavior: 'auto' });
          if (done.hasAttribute('tabindex')) done.focus({ preventScroll: true });
        }, 60);
      }
    }

    /* Questions fréquentes : ouverture / fermeture animées */
    root.querySelectorAll('[data-ahp-q]').forEach(function (q) {
      var sum = q.querySelector('summary');
      var body = q.querySelector('.ahp-q__body');
      if (!sum || !body || reduce || !body.animate) return;
      var anim = null;
      sum.addEventListener('click', function (e) {
        e.preventDefault();
        if (anim) anim.cancel();
        var opening = !q.open || q.classList.contains('is-closing');
        q.classList.remove('is-closing');
        if (opening) {
          q.open = true;
          var h = body.scrollHeight;
          anim = body.animate(
            [{ height: '0px', opacity: 0, transform: 'translateY(-6px)' }, { height: h + 'px', opacity: 1, transform: 'none' }],
            { duration: 520, easing: 'cubic-bezier(.2,.75,.15,1)' }
          );
        } else {
          q.classList.add('is-closing');
          anim = body.animate(
            [{ height: body.offsetHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
            { duration: 380, easing: 'cubic-bezier(.4,0,.2,1)' }
          );
          anim.onfinish = function () { q.open = false; q.classList.remove('is-closing'); };
        }
        anim.oncancel = function () { anim = null; };
      });
    });

    /* Bouton fixe sur mobile : visible après le haut de page, masqué près du formulaire */
    var sticky = root.querySelector('[data-ahp-sticky]');
    var hero = root.querySelector('.ahp-hero');
    var quote = root.querySelector('.ahp-quote');
    if (sticky && hero && quote && 'IntersectionObserver' in window) {
      var heroOut = false, quoteIn = false;
      var update = function () { sticky.classList.toggle('is-visible', heroOut && !quoteIn); };
      new IntersectionObserver(function (en) { heroOut = !en[0].isIntersecting; update(); }, { threshold: 0.05 }).observe(hero);
      new IntersectionObserver(function (en) { quoteIn = en[0].isIntersecting; update(); }, { threshold: 0 }).observe(quote);
    }
  }

  function boot() { document.querySelectorAll('[data-ahp]').forEach(init); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-ahp]');
    if (el) init(el);
  });
})();